<template>
  <v-col
    v-bind="settings"
    v-on="listeners"
  >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "SGPColComponent",
  computed: {
    settings () {
      return {
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    },
  }
}
</script>